@use 'sass:map';
@use 'variables' as *;
@use 'common/assets/scss/global' as *;

.header {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1030;

  > .mask {
    position: fixed;
    inset: 0;
    z-index: 4;
    background-color: rgba(#000000, 0.25);
  }

  > .topbar {
    position: relative;
    background-color: var(--#{$prefix}body-bg);
    box-shadow: var(--#{$prefix}shadow-strong) HEXToRGBA($black, 0.1);

    > .not-logged {
      display: flex;
      align-items: center;
      justify-content: center;

      > .logo {
        flex: 0 1 auto;
        height: 27px;
        width: auto;
      }

      > button,
      > a {
        flex: 0 0 auto;
        @include button-and-tag;
        font-family: $sora;
        padding: 6px 12px;
        font-weight: 600;
        font-size: var(--#{$prefix}font-size-md);
        margin-right: -12px;

        &:focus-visible {
          outline: 4px solid var(--#{$prefix}primary);
        }
      }
    }

    &::after {
      content: '';
      display: block;
      height: 0;
      transition: height 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &.search-open::after {
      height: calc(var(--recia-font-size-md) + #{2 * (8.5 + 16) + 5}px);
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > .topbar {
      > .not-logged {
        justify-content: unset;
      }

      &.search-open::after {
        height: calc(var(--recia-font-size-md) + #{2 * (11 + 16) + 5}px);
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, lg)) {
    > .topbar.search-open::after {
      height: 0;
    }
  }
}
